module.exports = __webpack_public_path__ + "static/img/todomath_main_feature_free_ko.66caa00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/todomath_main_feature_free_ko.png
// module id = PgVq
// module chunks = 18